import { storeCSRFToken } from "./session";

async function csrfFetch(url, options = {}) {
    options.method ||= 'GET'
    options.headers ||= {};

    if (options.method.toUpperCase() !== 'GET') {
        options.headers['X-CSRF-Token'] = sessionStorage.getItem('X-CSRF-Token');
        options.headers['Content-Type'] ||= 'application/json';
    }

    const res = await fetch(url, options);
    if (res.status >= 400) throw res;
    return res;
   

}

export async function restoreCSRF() {
    const res = await fetch("/api/session");
    storeCSRFToken(res);
}

export default csrfFetch;